import React from 'react';
import { Link } from 'react-router-dom';
import styles from './index.module.scss';

const FooterTextComponent = ({ contentText, contentTag, contentName }) => {
  const parseTextWithLink = (text) => {
    if (!text || typeof text !== 'string') return { displayText: text, sectionName: null };

    const starIndex = text.indexOf('*');
    if (starIndex === -1) {
      return { displayText: text, sectionName: null };
    }

    const displayText = text.substring(0, starIndex);
    const sectionName = text.substring(starIndex + 1);

    return { displayText, sectionName };
  };

  const hasInstagram = (text) => {
    if (!text || typeof text !== 'string') return false;
    return text.toLowerCase().includes('instagram');
  };

  const renderTextOrLink = (text, prefix = '') => {
    const { displayText, sectionName } = parseTextWithLink(text);

    const fullText = prefix ? `${prefix} ${displayText}` : displayText;
    const showAsterisk = hasInstagram(displayText);

    if (sectionName) {
      const path = sectionName === 'main_tab' ? '/' : `/${sectionName}`;
      return (
        <span className={styles.textWrapper}>
          {showAsterisk && <span className={styles.asterisk}>*</span>}
          <Link to={path} className={styles.link}>
            {fullText}
          </Link>
        </span>
      );
    }

    if (showAsterisk) {
      return (
        <span className={styles.textWrapper}>
          <span className={styles.asterisk}>*</span>
          {fullText}
        </span>
      );
    }

    return fullText;
  };

  const renderContent = () => {
    if (!contentText) return null;

    switch (contentTag) {
      case 'ip':
        return <p className={styles.text}>{renderTextOrLink(contentText, 'ИП')}</p>;
      case 'ornip':
        return <p className={styles.text}>{renderTextOrLink(contentText, 'ОГРНИП')}</p>;
      case 'phone':
        return <p className={styles.text}>{renderTextOrLink(contentText, 'телефон:')}</p>;
      case 'email':
        return <p className={styles.text}>{renderTextOrLink(contentText, 'email:')}</p>;
      case 'address':
        return <p className={styles.text}>{renderTextOrLink(contentText, 'адрес:')}</p>;
      case 'inn':
        return <p className={styles.text}>{renderTextOrLink(contentText, 'ИНН:')}</p>;
      default:
        return <p className={styles.text}>{renderTextOrLink(contentText)}</p>;
    }
  };

  return (
    <div className={styles.footerTextComponent}>
      {renderContent()}
    </div>
  );
};

export default FooterTextComponent;
